<mat-card class="card-actions h-100 report-filter-card">
  <mat-card-content>
    <div class="filter-toolbar">
      <div class="filter-section employee-filter">
        <span class="filter-caption">Empleado</span>
        <div class="employee-control">
          <button mat-stroked-button color="primary" class="employee-picker" (click)="openModalNomina()"
            aria-label="Seleccionar empleado" matTooltip="Seleccionar empleado">
            <mat-icon>search</mat-icon>
            <span>{{ empleadoSelected ? 'Cambiar' : 'Seleccionar' }}</span>
          </button>
          <div class="info-empleado" [class.empty-employee]="!empleadoSelected">
            <span>{{ getEmpleadoSelected() || 'Todos los empleados' }}</span>
            <small *ngIf="empleadoSelected?.Seccion">{{ empleadoSelected.Seccion }}</small>
          </div>
        </div>
      </div>

      <div class="filter-section period-filter">
        <mat-checkbox class="period-checkbox" [checked]="chkSeleccionarPeriodo"
          (change)="checkboxSelect($event)">
          Filtrar por período anual
        </mat-checkbox>
        <mat-form-field appearance="outline" class="period-select">
          <mat-label>Año</mat-label>
          <mat-select [(ngModel)]="periodoAnualSelected"
            [disabled]="!chkSeleccionarPeriodo || !periodosAnualesList?.length">
            <mat-option *ngFor="let item of periodosAnualesList" [value]="item">
              {{ item }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-actions">
        <button mat-stroked-button class="export-button" matTooltip="Exportar reporte"
          aria-label="Exportar reporte" (click)="printFile()">
          <mat-icon>download</mat-icon>
          <span>Exportar</span>
        </button>
        <button mat-raised-button color="primary" class="search-button" (click)="buscar()">
          <mat-icon>search</mat-icon>
          <span>Buscar</span>
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
